const CHECK_CIRCLE_OUTLINE = "check-circle-outline";
const CLOCK_OUTLINE = "clock-outline";

export const ICONS_NATIVE_MISC = {
  ACCOUNT: "account",
  ACCOUNT_OUTLINE: "account-outline",
  ALERT_OUTLINE: "alert-outline",
  ALERT_CIRCLE_OUTLINE: "alert-circle-outline",
  ARROWBACKWARD: "arrow-back-ios",
  ARROWFORWARD: "arrow-forward-ios",
  BLUETOOTH: "bluetooth",
  BULLSEYE_ARROW: "bullseye-arrow",
  CALENDAROUTLINE: "calendar-month-outline",
  CALL_RECEIVED: "call-received",
  CAMERA_OUTLINE: "camera-outline",
  CAMERA_PLUS_OUTLINE: "camera-plus-outline",
  CANCEL: "cancel",
  CHECK_CIRCLE_OUTLINE,
  CHECK: "check",
  CHECKBOX_BLANK_OUTLINE: "checkbox-blank-outline",
  CHECKBOX_MARKED: "checkbox-marked",
  CHEVRON_DOWN: "chevron-down",
  CHEVRON_LEFT: "chevron-left",
  CHEVRON_RIGHT: "chevron-right",
  CHEVRON_UP: "chevron-up",
  CLIPBOARD_TEXT_OUTLINE: "clipboard-text-outline",
  CLOCK: "clock",
  CLOCK_OUTLINE: "timer-outline",
  CLOSE: "close",
  COG: "cog",
  COG_OUTLINE: "cog-outline",
  DOCUMENT: "file-document-outline",
  DRAG: "drag",
  EMAIL: "email",
  FILTER_VARIANT: "filter-variant",
  FLOOR_PLAN: "floor-plan",
  GLOBAL_SEARCH: "travel-explore",
  HELP_CIRCLE_OUTLINE: "help-circle-outline",
  HOME: "home",
  HOME_GROUP: "home-group",
  HOME_OUTLINE: "home-outline",
  INFORMATION_OUTLINE: "information-outline",
  LIST_BULLETED: "format-list-bulleted",
  LOCK_OUTLINE: "lock-outline",
  LOGOUT: "logout",
  MENU: "menu",
  PENCIL_OUTLINE: "pencil-outline",
  PHONE: "phone",
  PLAY: "play",
  PLUS: "plus",
  MINUS: "minus",
  REFRESH: "refresh",
  SEND: "send",
  TIMER_OUTLINE: "timer-outline",
  THUMB_UP_OUTLINE: "thumb-up-outline",
  THUMB_DOWN_OUTLINE: "thumb-down-outline",
  THUMB_DOWN: "thumb-down",
  THUMB_UP: "thumb-up",
  TRASH_CAN_OUTLINE: "trash-can-outline",
  UNDO: "undo",
  VIDEO_OFF: "video-off",
  VIDEO_OUTLINE: "video-outline",
  VIDEO_PLUS_OUTLINE: "video-plus-outline",
  WALK: "walk",
  WIFI_OFF: "wifi-off",
  WIFI: "wifi",
  ACCOUNT_CONVERT: "account-convert",
  DOWNLOAD: "cloud-download",
  NOT_DOWNLOADED: "cloud-download-outline",
  STOP_VIDEO_RECORDING: "stop",
  RECORDING_VIDEO: "radiobox-marked",
  PAUSED: "pause",
  RESUME_VIDEO_RECORDING: "record",
  TASK_ALT: "task-alt",
  SYNC: "sync",
  HAMMER_SCREWDRIVER: "hammer-screwdriver",
  STAR: "star",
  STAR_OUTLINE: "star-outline",
  CHART_SANKEY_VARIANT: "chart-sankey-variant",
  EYE_OUTLINE: "eye-outline",
  EMAIL_OUTLINE: "email-outline",
};

export const ICONS_NATIVE_ALERT = {
  ERROR: "alert-outline",
  INFO: "information-outline",
  SUCCESS: CHECK_CIRCLE_OUTLINE,
  WARNING: "alert-outline",
};

export const ICONS_NATIVE_STATUS = {
  CANCELLED: "cancel",
  CLOSED: "close",
  CLOSEOUT_INPROGRESS: "playlist-check",
  COMPLETED: "thumb-up",
  COMPLETED_OUTLINE: "thumb-up-outline",
  COMPLETE: CHECK_CIRCLE_OUTLINE,
  ENROUTE: "car-outline",
  FAILED: "thumb-down",
  FAILED_OUTLINE: "thumb-down-outline",
  HOLD: "hand-back-right",
  HOLD_OUTLINE: "hand-back-right-outline",
  INCOMPLETE_DOWN: "thumb-down",
  INCOMPLETE: "close-circle-outline",
  INPROGRESS: CLOCK_OUTLINE,
  NA: "do-not-disturb-alt",
  NEW: "checkbox-blank-circle-outline",
  NEW_TASK: "clock",
  PENDING: CLOCK_OUTLINE,
  READY: "calendar",
  RELEASED: "calendar-start",
  SUBMITTED: "check",
  UNABLE_TO_START: "close-circle-outline",
  VERIFIED: "thumb-up",
  SCHEDULED: CLOCK_OUTLINE,
  WORK_COMPLETE: "check-circle",
};

export const ICONS_NATIVE_CONTROLS = {
  ...ICONS_NATIVE_STATUS,
  ARROW_RIGHT: "arrow-right",
  CAMERA_OUTLINE: "camera-outline",
  CAMERA_RETAKE: "camera-retake-outline",
  THUMB_DOWN: "thumb-down",
  THUMB_UP: "thumb-up",
  UNDO_VARIANT: "undo-variant",
  DELETE: "trash-can-outline",
  LINK: "link",
  UNLINK: "link-off",
  VIDEO_OUTLINE: "video-outline",
};

export const ICONS_WEB = {
  ACCOUNT_HARDHAT_OUTLINE: "mdiAccountHardHatOutline",
  ACCOUNT_TIE_HAT_OUTLINE: "mdiAccountTieHatOutline",
  ACCOUNT_OFF: "mdiAccountOff",
  ACCOUNT: "mdiAccount",
  ACCOUNT_OUTLINE: "mdiAccountOutline",
  ACCOUNT_LOCK_OPEN: "mdiAccountLockOpen",
  ACCOUNT_GROUP: "mdiAccountGroup",
  ALERT: "mdiAlert",
  ALERT_OUTLINE: "mdiAlertOutline",
  ARCHIVE_OUTLINE: "mdiArchiveOutline",
  ARROW_DOWN: "mdiArrowDown",
  ARROW_LEFT: "mdiArrowLeft",
  ARROW_LEFT_CIRCLE: "mdiArrowLeftCircleOutline",
  ARROW_RIGHT_CIRCLE: "mdiArrowRightCircleOutline",
  ARROW_U_LEFT_TOP: "mdiArrowULeftTop",
  ARROW_UP: "mdiArrowUp",
  BOOK_OPEN_OUTLINE: "mdiBookOpenBlankVariantOutline",
  BULLET_LIST: "mdiFormatListBulleted",
  CANCEL: "mdiCancel",
  CAR_ESTATE: "mdiCarEstate",
  CHECK_ALL: "mdiCheckAll",
  CHECK_CIRCLE: "mdiCheckCircle",
  CHECK: "mdiCheck",
  CHECKBOX_MARKED: "mdiCheckboxMarked",
  CHEVRON_DOWN: "mdiChevronDown",
  CHEVRON_LEFT: "mdiChevronLeft",
  CHEVRON_RIGHT: "mdiChevronRight",
  CHEVRON_UP: "mdiChevronUp",
  CITY: "mdiCity",
  CIRCLE_SLICE: "mdiCircleSlice8",
  CLIPBOARD_SEARCH_OUTLINE: "mdiClipboardSearchOutline",
  CLOCK_OUTLINE: "mdiClockOutline",
  CLOCK: "mdiClock",
  CLOSE_BOX: "mdiCloseBox",
  CLOSE_CIRCLE: "mdiCloseCircle",
  CLOSE: "mdiClose",
  COG: "mdiCogOutline",
  COPY: "mdiContentCopy",
  CURRENCY: "mdiCurrencyUsd",
  CALENDAR: "mdiCalendar",
  CALENDAR_REFRESH: "mdiCalendarRefresh",
  CALENDAR_BLANK: "mdiCalendarBlank",
  CALENDAR_BLANK_OUTLINE: "mdiCalendarBlankOutline",
  CALENDAR_START_OUTLINE: "mdiCalendarStartOutline",
  DELETE: "mdiDelete",
  DOCUMENT: "mdiFileDocumentOutline",
  DRAG: "mdiDrag",
  DROP_LABOR: "mdiTools",
  DROP_MATERIALS: "mdiHexagonOutline",
  DASHBOARD: "mdiViewDashboardOutline",
  FLOOR_PLAN: "mdiFloorPlan",
  HEADSET: "mdiHeadset",
  HELP_CIRCLE: "mdiHelpCircle",
  HELP_CIRCLE_OUTLINE: "mdiHelpCircleOutline",
  HEXAGON_OUTLINE: "mdiHexagonOutline",
  HISTORY: "mdiHistory",
  HOME: "mdiHomeOutline",
  HOME_CITY_OUTLINE: "mdiHomeCityOutline",
  HOME_GROUP: "mdiHomeGroup",
  IMAGE_OFF: "mdiImageOffOutline",
  IMAGE_PLUS_OUTLINE: "mdiImagePlusOutline",
  INFORMATION_OUTLINE: "mdiInformationOutline",
  LOCK_OUTLINE: "mdiLockOutline",
  MAGNIFY: "mdiMagnify",
  MENU: "mdiDotsVertical",
  MENU_UP: "mdiMenuUp",
  MENU_DOWN: "mdiMenuDown",
  MINUS_BOX: "mdiMinusBox",
  MINUS_CIRCLE: "mdiMinusCircle",
  MINUS: "mdiMinus",
  NOTE_TEXT_OUTLINE: "mdiNoteTextOutline",
  PACKAGE_CLOSED: "mdiPackageVariantClosed",
  PAUSED: "mdiPauseCircleOutline",
  PENCIL_OUTLINE: "mdiPencilOutline",
  PENCIL: "mdiPencil",
  PRINTER_OUTLINE: "mdiPrinterOutline",
  PHONE: "mdiPhone",
  PLUS: "mdiPlus",
  PLUS_CIRCLE: "mdiPlusCircle",
  CLOCK_TIME_FIVE_OUTLINE: "mdiClockTimeFiveOutline",
  SAVE: "mdiContentSave",
  TEXTBOX_PLUS_OUTLINE: "mdiTextBoxPlusOutline",
  THUMB_DOWN: "mdiThumbDown",
  THUMB_UP: "mdiThumbUp",
  TIMER_SAND: "mdiTimerSand",
  TOOLS: "mdiTools",
  TRASH_CAN: "mdiTrashCanOutline",
  TRUCK: "mdiTruckCargoContainer",
  UNDO: "mdiUndo",
  UPLOAD: "mdiTrayArrowUp",
  VIEW_COMPACT: "mdiViewCompactOutline",
  WALL: "mdiWall",
  ACTIVATE: "mdiAccountReactivateOutline",
  CUSTOMER_OUTLINE: "mdiClipboardAccountOutline",
  CHART_SANKEY_VARIANT: "mdiChartSankeyVariant",
};
